import { render, staticRenderFns } from "./ContratosOcorrencia.vue?vue&type=template&id=6296e579&"
import script from "./ContratosOcorrencia.vue?vue&type=script&lang=js&"
export * from "./ContratosOcorrencia.vue?vue&type=script&lang=js&"
import style0 from "./ContratosOcorrencia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports